// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-3-m__wrapper__2k03Q","headline":"card-image-type-3-m__headline__GLxsG"};